export default __webpack_public_path__ + "static/media/ordered-list.94e949d5.svg";